import React, { useState, useContext, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Avatar,
  Modal,
  Form,
  Input,
  Upload as UploadAntd,
  Image,
} from "antd";
import profilavatar from "../assets/images/profilImage.jpg";
import Main from "../components/layout/Main";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import { AuthContext } from "../context/AuthContext";
import { ExclamationCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";
import PhoneInput from "react-phone-input-2";
import SingleImageUpload from "../components/SingleImageUpload";
import notfound from "../assets/images/not_found.png";

const s3Config = {
  region: "us-east-1",
  credentials: {
    accessKeyId: "IJTXH751MBXUWMTWM0SF",
    secretAccessKey: "lfTPRJ2PqAxsp3poTW9YlHktgaL1cFkLup8LidW9",
  },
  endpoint: "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/",
  forcePathStyle: true,
};

const s3Client = new S3Client(s3Config);
function Profile() {
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState({});
  const { logout } = useContext(AuthContext);
  const [visible, setVisible] = useState(false);
  const [profileVisible, setProfileVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [refresh, setRefresh] = useState(false);
  const [form] = Form.useForm();
  const { request } = useRequest();
  const { confirm } = Modal;

  useEffect(() => {
    request({
      url: "/auth/get-profile",
      method: "GET",
      onSuccess: (data) => {
        // ShowToast(data.message, Severty.SUCCESS)
        if (data && data.data) {
          setProfile(data.data);
          setSelected(data.data);
        } else {
          console.error("Invalid response data:", data);
          ShowToast("Failed to load profile data", Severty.ERROR);
        }
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  }, [refresh]);

  const showConfirm = () => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want to logout ? </Button>,
        onOk() {
          logout();
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  console.log("profile--->", profile);
  return (
    <div>
      <Card
        className="card-profile-head"
        bodyStyle={{ display: "none" }}
        title={
          <Row justify="space-between" align="middle" gutter={[24]}>
            <Col span={24} md={24}>
              <Avatar.Group>
                <Avatar
                  size={74}
                  shape="square"
                  src={profile.profile_img ? profile.profile_img : profilavatar}
                />
                <div className="avatar-info profile-detail-div">
                  <h4
                    className="font-semibold m-0 profile-name"
                    style={{ color: "black" }}
                  >
                    {profile ? profile.full_name : ""}
                  </h4>
                  <p>{profile ? profile.email : ""}</p>
                  <p>{profile ? profile.country_code : ""} {profile ? profile.mobile : ""}</p>
                </div>
              </Avatar.Group>
            </Col>
          </Row>
        }
      ></Card>

      <Card className="profile-nav">
        <div className="profile-nav-inner">
          <Button onClick={(e) => setProfileVisible(true)}>Edit Profile</Button>
          <Button onClick={(e) => setVisible(true)}>Change Password</Button>
          {/* <Button onClick={() => showFactoryData()} >Factory Data Reset</Button> */}
          <Button onClick={() => showConfirm()}>Logout</Button>
        </div>
      </Card>

      {profileVisible && (
        <EditProfile
          show={profileVisible}
          hide={() => {
            setProfileVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {visible && (
        <ChangePassword
          show={visible}
          hide={() => {
            setVisible(false);
          }}
          // handleCreate={handleCreate}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </div>
  );
}

const EditProfile = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [image, setImage] = useState();
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [tempProfileData, setTempProfileData] = useState(null);
  const [form1] = Form.useForm();
  const [selected, setSelected] = useState();
  const [countryCode, setCountryCode] = useState("");
  const [form2] = Form.useForm();
  const { setUserProfile } = useContext(AuthContext);
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp"];

  const beforeUpload = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      // ShowToast(`Image must be smaller than 5 MB!`, Severty.ERROR)
      return false;
    }
    return true;
  };

  const uploadFileToS3 = async (file, bucketName) => {
    const key = "realState/admin" + file.name;
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3Client,
      params: params,
    });

    try {
      const data = await upload.done();
      setLoading(false);
      console.log(data);
      return data;
    } catch (err) {
      throw err;
    }
  };

  const handleChange = async (event) => {
    // Check if event and file exist
    if (!event || !event.file) {
      console.error("Invalid event or file object:", event);
      return;
    }

    const { file } = event;

    // Check if file has required properties
    if (!file || !file.type || !file.size) {
      console.error("Invalid file object:", file);
      ShowToast("Invalid file selected", Severty.ERROR);
      return;
    }

    let validateImage =
      file.type.includes("image") &&
      !file.type.includes("svg") &&
      !file.type.includes("gif");
    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }

    const isValidSize = beforeUpload(file);

    if (!isValidSize) {
      return ShowToast(
        "Image must be smaller than 5 MB!" + file.size / 1024 / 1024,
        Severty.ERROR
      );
    }

    setLoading(true);
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file?.uid || `file_${Date.now()}`, // Provide fallback uid if not present
        name: file?.name || "uploaded_file",
        status: "done",
        url: data?.Location,
        thumbUrl: data?.Location,
      };
      setFile([fileData]);
      console.log(data);
    } catch (err) {
      console.error(err);
      setLoading(false);
      setFile([]); // Reset file state on error
      ShowToast("Failed to upload file", Severty.ERROR);
    }
  };

  const handleOtpSubmit = (payload) => {
    if (!payload) {
      ShowToast("Profile data not available", Severty.ERROR);
      return;
    }

    setLoading(true);
    request({
      url: "/api/admin/users",
      method: "PUT",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        setShowOtpModal(false);
        if (data && data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          setUserProfile(data?.data); // update global user profile
          localStorage.setItem("userProfile", JSON.stringify(data?.data)); // persist profile

          hide();
          refresh();
        } else {
          ShowToast(data?.message || "Update failed", Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(
          error?.response?.data?.message || "Update failed",
          Severty.ERROR
        );
        setLoading(false);
      },
    });
  };

  const handleVerifyOTP = (values) => {
    const { otp } = values;
    // Verify the OTP entered by the user
    let payload = {};

    if (!selected || !selected.email) {
      ShowToast("Selected email not available", Severty.ERROR);
      return;
    }

    payload.email = selected.email;
    payload.otp = otp;
    request({
      url: "/admin/auth/profile-verify-otp",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        ShowToast(data.message, Severty.SUCCESS);
        setShowOtpModal(false);
        setOtp(otp);
        if (tempProfileData) {
          handleOtpSubmit(tempProfileData);
        } else {
          ShowToast("Profile data not available", Severty.ERROR);
        }
        // setVisible(false);
        // setResetModal(true);
        // form2.resetFields();
      },
      onError: (error) => {
        ShowToast(
          error?.response?.data?.message || "OTP verification failed",
          Severty.ERROR
        );
      },
    });
  };

  const handleImage = (data) => {
    data.length > 0 ? setImage(data?.[0]?.url) : setImage("");
  };

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({
      ...data,
      mobile: `${data.country_code.replace(/\+/g, "")}${data.mobile}`,
    });

    setCountryCode(data.country_code.replace(/\+/g, ""));

    if (data.profile_img) {
      setFile([data.profile_img]);
    }
  }, [data]);

  const onEditProfile = (values) => {
    const { email, full_name, username, mobile, country_code } = values;
    // Check if data exists before proceeding
    if (!data) {
      ShowToast("Profile data not available", Severty.ERROR);
      return;
    }
    const updatedProfilePic =
      (file && file.length > 0 && file[0] ? file[0].url : null) ??
      data?.profile_img;
    const isNameChanged =
      (full_name || "").trim() !== (data?.full_name || "").trim();
    const isMobile = (mobile || "").trim() !== (data?.mobile || "").trim();
    const isEmailChanged =
      (email || "").trim().toLowerCase() !==
      (data?.email || "").trim().toLowerCase();
    const isUsername =
      (username || "").trim() !== (data?.username || "").trim();
    const isProfilePicChanged = updatedProfilePic !== data?.profile_img;
    if (
      !isNameChanged &&
      !isEmailChanged &&
      !isProfilePicChanged &&
      !isMobile &&
      !isUsername
    ) {
      return ShowToast("No changes detected", Severty.ERROR);
    }

    const payload = {};
    setLoading(true);
    payload.email = email;
    payload.full_name = full_name;
    payload.profile_img = image;
    payload.username = username;
    payload.country_code = countryCode;
    payload.mobile = mobile.slice(countryCode.length);
    setTempProfileData(payload);
    if (!isEmailChanged) {
      handleOtpSubmit(payload);
      return;
    }
    request({
      url: "/auth/profile/update",
      method: "PUT",
      data: payload,
      onSuccess: (res) => {
        ShowToast(
          res?.message || "Profile updated successfully",
          Severty.SUCCESS
        );
        if (res?.data) {
          setUserProfile(res.data);
          console.log(res.data)
          localStorage.setItem("userProfile", JSON.stringify(res.data));
        }
        hide();
        refresh()
        setShowOtpModal(false);
        form1.resetFields();
        setSelected({ email });
      },
      onError: (error) => {
        ShowToast(
          error?.response?.data?.message || "Failed to generate OTP",
          Severty.ERROR
        );
      },
    });
    // request({
    //   url: "/admin/auth/update-profile",
    //   method: "POST",
    //   data: payload,
    //   onSuccess: (data) => {
    //     setLoading(false);
    //     if (data.status) {
    //       ShowToast(data.message, Severty.SUCCESS);
    //       hide();
    //       refresh();
    //       // hide()
    //     } else {
    //       ShowToast(data.message, Severty.ERROR);
    //     }
    //   },
    //   onError: (error) => {
    //     ShowToast(error.response.data.message, Severty.ERROR);
    //     // console.log(error.response.data, "Error")
    //     setLoading(false);
    //   },
    // });
  };

  return (
    <>
      <Modal
        visible={show}
        title={`${data ? "Edit Profile" : ""}`}
        okText="Ok"
        onCancel={hide}
        okButtonProps={{
          form: "create",
          htmlType: "submit",
          // loading: loading,
        }}
      >
        <Form
          id="create"
          form={form}
          onFinish={onEditProfile}
          layout="vertical"
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label="Name"
                name="full_name"
                rules={[
                  { required: true, message: "Please input the name!" },
                  {
                    pattern: /^[a-zA-Z]+(?: [a-zA-Z]+)*$/,
                    message: "Only Alphabetic Characters Allowed",
                  },
                  {
                    max: 50,
                    message: "Name cannot exceed 50 characters",
                  },
                ]}
                // normalize={(value)=>value?.trim()}
              >
                <Input placeholder={"Enter Full Name"} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  {
                    max: 50,
                    message: "Name cannot exceed 50 characters",
                  },
                ]}
                // normalize={(value)=>value?.trim()}
              >
                <Input placeholder={"Enter User Name"} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "The input is not valid E-mail!",
                  },
                  { required: true, message: "Please input the email!" },
                  {
                    max: 100,
                    message: "Email cannot exceed 100 characters",
                  },
                ]}
                normalize={(value) => value?.trim()}
              >
                <Input placeholder={"Email"} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="mobile"
                rules={[
                  { required: true, message: "Please enter your phone number" },
                  () => ({
                    validator(_, value) {
                      if (!value) return Promise.resolve();

                      // remove everything except digits
                      const digitsOnly = value.replace(/\D/g, "");

                      // remove country code digits
                      const localNumber = countryCode
                        ? digitsOnly.replace(new RegExp(`^${countryCode}`), "")
                        : digitsOnly;

                      // digits only check
                      if (!/^\d+$/.test(localNumber)) {
                        return Promise.reject(
                          new Error("Phone number must contain only digits")
                        );
                      }

                      // India mobile validation (10 digits)
                      if (localNumber.length < 7 || localNumber.length > 10) {
                        return Promise.reject(
                          new Error("Enter a valid mobile number")
                        );
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <PhoneInput
                  country="in"
                  enableSearch
                  value={form1.getFieldValue("mobile")}
                  onChange={(value, country) => {
                    setCountryCode(country.dialCode); // store country code separately
                    form1.setFieldsValue({ mobile: value });
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "57px",
                    borderRadius: "12px",
                    background: "transparent",
                    color: "white",
                    border: "1px solid #d9d9d9",
                    fontSize: "16px",
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24} md={12}>
              <Form.Item
                className=""
                label="Upload Image"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value !== undefined && value?.length > 0) {
                        return Promise.resolve();
                      }
                      // return Promise.reject(new Error(lang("Image is required")));
                      return Promise.resolve();
                    },
                  },
                ]}
                name="image"
              >
                <SingleImageUpload
                  value={image}
                  fileType={FileType}
                  imageType={"Profile"}
                  btnName={"Image"}
                  onChange={(data) => handleImage(data)}
                  isDimension={false}
                />
              </Form.Item>
              <p className="img-size-details">
                You can select only image files upto 5 MB file size
              </p>
              {
                <div className="mt-2 add-img-product">
                  {" "}
                  {image ? (
                    <Image width={120} src={image ?? notfound}></Image>
                  ) : (
                    ""
                  )}{" "}
                </div>
              }
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        open={showOtpModal}
        title="Verify OTP"
        okText="Ok"
        onCancel={() => {
          setShowOtpModal(false);
          form2.resetFields();
        }}
        okButtonProps={{
          form: "verify-otp",
          htmlType: "submit",
          // loading: loading,
        }}
      >
        <Form
          id="verify-otp"
          form={form2}
          onFinish={(e) => handleVerifyOTP(e)}
          layout="vertical"
        >
          <Form.Item
            label="OTP"
            name="otp"
            normalize={(value) => value?.trim()}
            rules={[
              {
                required: true,
                message: "Please enter the OTP",
              },
              {
                pattern: /^\d{6}$/,
                message: "OTP must be 6 digits",
              },
            ]}
          >
            <Input type="number" placeholder="Enter OTP" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

const ChangePassword = ({ show, hide }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const { logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const handleCreate = (values) => {
    // const { current_password, new_password, confirm_new_password } = values;
    const current_password = (values?.current_password || "").trim();
    const new_password = (values?.new_password || "").trim();
    const confirm_new_password = (values?.confirm_new_password || "").trim();
    const payload = {};
    if (!current_password || !new_password || !confirm_new_password)
      return ShowToast("Please enter password ", Severty.ERROR);
    if (new_password !== confirm_new_password) {
      ShowToast("Passwords that you entered do not match!", Severty.ERROR);
      return;
    }
    setLoading(true);
    payload.current_password = current_password;
    payload.new_password = new_password;
    payload.confirm_new_password = confirm_new_password;
    request({
      url: "/auth/change-password",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data && data.status) {
          ShowToast(
            data?.message || "Password changed successfully",
            Severty.SUCCESS
          );
          // Logout after change password
          setTimeout(() => {
            hide();
            setLoading(false);
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("session_id");
            window.location.assign("/login");
          }, 1000);
        } else {
          ShowToast(data?.message || "Password change failed", Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(
          error?.response?.data?.message || "Password change failed",
          Severty.ERROR
        );
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      title="Change password"
      okText="Ok"
      onCancel={() => {
        hide();
        form.resetFields();
      }}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form
        id="create"
        form={form}
        layout="vertical"
        onFinish={handleCreate}
        className="change-pw"
        disabled={loading}
      >
        <Form.Item
          label="Old Password"
          name="current_password"
          hasFeedback
          rules={[
            { required: true, message: "Please input the old password!" },
          ]}
        >
          <Input.Password maxLength={50} placeholder={"Old Password"} />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="new_password"
          normalize={(value) => value?.trim()}
          hasFeedback
          rules={[
            { required: true, message: "Please input the new password!" },
            {
              min: 8,
              message: "Password must be at least 8 characters long!",
            },
            {
              pattern:
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+={}[\]|\\:;"'<>,.?/~`]).+$/,
              message:
                "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character!",
            },
            {
              max: 100,
              message: "Password cannot exceed 100 characters",
            },
          ]}
        >
          <Input.Password maxLength={50} placeholder={"New Password"} />
        </Form.Item>
        <Form.Item
          label="Confirm New Password"
          name="confirm_new_password"
          dependencies={["new_password"]}
          hasFeedback
          rules={[
            { required: true, message: "Please input the confirm password!" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Passwords that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password maxLength={50} placeholder={"Confirm New Password"} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Profile;
